import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import "../styles/carview.css";
import { BsFuelPumpFill } from "react-icons/bs";
import { TbEngine, TbStars } from "react-icons/tb";
import { AiOutlineNodeIndex, AiOutlineColumnWidth } from "react-icons/ai";
import {
  MdCompareArrows,
  MdOutlinePropaneTank,
  MdAirlineSeatReclineExtra,
} from "react-icons/md";
import { GiBackwardTime } from "react-icons/gi";
import { useCart } from "../context/cart";
import toast from "react-hot-toast";
import { AiOutlineEye } from "react-icons/ai";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { ColorRing } from "react-loader-spinner";
import { server } from "../server";
import { RiHeartAddLine } from "react-icons/ri";
import { GoHeart } from "react-icons/go";
import { FaHeadphonesAlt } from "react-icons/fa";
import { SiWhatsapp } from "react-icons/si";
import { Helmet } from "react-helmet";

const CarView = () => {
  const params = useParams();
  const [car, setCar] = useState({
    name: "",
    description: "",
    documents: [],
    price: "",
    brand: { name: "", image: [{ url: "" }] },
    fuelTank: "",
    fuelType: "",
    mileage: "",
    safetyrating: "",
    warranty: "",
    seater: "",
    size: "",
    slug: "",
    yom: "",
    transmission: "",
    horsepower: "",
    engineSize: "",
    drive: "",
    torque: "",
    accelaration: "",
  });
  const [cart, setcart] = useCart();
  const [relatedCar, setRelatedCar] = useState([]);
  const [loading, setLoading] = useState(true);

  const getRelatedCar = useCallback(async (cid, bid) => {
    try {
      const { data } = await axios.get(
        `${server}/api/car/related-car/${cid}/${bid}`,
      );
      setRelatedCar(data?.cars);
    } catch (err) {
      console.log(err);
    }
  }, []);

  const getCar = useCallback(async () => {
    try {
      const { data } = await axios.get(
        `${server}/api/car/getCarById-car/${params.slug}`,
      );
      setCar(data.car);
      getRelatedCar(data?.car._id, data?.car.brand._id);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(true);
    }
  }, [params.slug, getRelatedCar]);

  useEffect(() => {
    if (params?.slug) {
      getCar();
    }
    window.scrollTo(0, 0);
  }, [getCar, params?.slug]);

  const notify = () => toast.success("Added To Cart Successfully");

  const updatedAt = new Date(car.updatedAt).toLocaleString();
  const year = new Date(car.updatedAt).getFullYear();

  const galleryImages =
    car.documents?.map((picture) => ({
      original: picture.url,
      thumbnail: picture.url,
    })) || [];

  // Breadcrumb path
  const breadcrumbPath = [
    { name: "Home", path: "/" },
    { name: "Cars", path: "/cars" },
    { name: car.brand?.name || "Brand", path: `/brand/${car.brand?.slug}` },
    { name: car.name || "Car", path: "" },
  ];

  // Generate structured data for SEO
  const generateStructuredData = () => {
    return {
      "@context": "https://schema.org",
      "@type": "Product",
      name: car.name,
      image: car.documents?.map((pic) => pic.url) || [],
      description: car.description,
      brand: {
        "@type": "Brand",
        name: car.brand?.name,
      },
      offers: {
        "@type": "Offer",
        url: window.location.href,
        priceCurrency: "KES",
        price: car.price,
        availability: "https://schema.org/InStock",
        seller: {
          "@type": "Organization",
          name: "Classic Motors KE",
          telephone: "+254707308556",
          address: {
            "@type": "PostalAddress",
            addressLocality: "Mombasa",
            addressCountry: "KE",
          },
        },
      },
      vehicleDetails: {
        "@type": "Vehicle",
        mileageFromOdometer: {
          "@type": "QuantitativeValue",
          value: car.mileage,
          unitCode: "KM",
        },
        vehicleEngine: {
          "@type": "EngineSpecification",
          engineDisplacement: {
            "@type": "QuantitativeValue",
            value: car.engineSize,
            unitCode: "CC",
          },
          fuelType: car.fuelType,
        },
        vehicleTransmission: car.transmission,
        numberOfPreviousOwners: "1",
        productionDate: car.yom,
      },
    };
  };

  return (
    <div className="container marginStyle" style={{ marginTop: "80px" }}>
      <Helmet>
        <title>{`${car.name} for Sale in Kenya | ${car.brand?.name} cars in Kenya | Classic Motors KE`}</title>
        <meta
          name="description"
          content={`Buy ${car.name} in Kenya at ${Number(
            car.price,
          ).toLocaleString()} KES. ${car.description.substring(0, 160)}...`}
        />
        <meta
          name="keywords"
          content={`${car.name}, ${car.brand?.name} cars Kenya, used cars Mombasa, car dealers Kenya, ${car.fuelType} cars, ${car.yom} ${car.brand?.name}`}
        />

        <link
          rel="canonical"
          href={`https://classicmotorske.com/car/${car.slug}`}
        />

        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`https://classicmotorske.com/car/${car.slug}`}
        />
        <meta
          property="og:title"
          content={`${car.name} for Sale in Kenya | Classic Motors KE`}
        />
        <meta
          property="og:description"
          content={`Buy ${car.name} in Kenya at ${Number(
            car.price,
          ).toLocaleString()} KES. ${car.description.substring(0, 160)}...`}
        />
        <meta property="og:image" content={car.documents?.[0]?.url || ""} />

        <meta property="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:url"
          content={`https://classicmotorske.com/car/${car.slug}`}
        />
        <meta
          property="twitter:title"
          content={`${car.name} for Sale in Kenya | Classic Motors KE`}
        />
        <meta
          property="twitter:description"
          content={`Buy ${car.name} in Kenya at ${Number(
            car.price,
          ).toLocaleString()} KES. ${car.description.substring(0, 160)}...`}
        />
        <meta
          property="twitter:image"
          content={car.documents?.[0]?.url || ""}
        />

        <script type="application/ld+json">
          {JSON.stringify(generateStructuredData())}
        </script>
      </Helmet>

      <nav aria-label="breadcrumb" className="mb-4">
        <ol className="breadcrumb">
          {breadcrumbPath.map((item, index) => (
            <li
              key={index}
              className={`breadcrumb-item ${
                index === breadcrumbPath.length - 1 ? "active" : ""
              }`}
            >
              {item.path ? (
                <Link to={item.path}>{item.name}</Link>
              ) : (
                <span>{item.name}</span>
              )}
              {index < breadcrumbPath.length - 1 && (
                <span className="mx-2"> </span>
              )}
            </li>
          ))}
        </ol>
      </nav>

      {loading ? (
        <div className="h-100 d-flex align-items-center justify-content-center">
          <ColorRing
            visible={true}
            colors={[
              "#000435",
              "rgb(14 165 233)",
              "rgb(243 244 246)",
              "#000435",
              "rgb(14 165 233)",
            ]}
          />
        </div>
      ) : (
        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <ImageGallery
                items={galleryImages}
                originalHeight={10}
                lazyLoad={true}
                showNav={false}
                showFullscreenButton={false}
                showPlayButton={false}
                additionalClass="car-gallery"
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="centerMob">
              <Link
                to={`/brand/${car.brand?.slug}`}
                className="text-decoration-none"
              >
                <img
                  decoding="async"
                  src={car.brand?.image?.[0]?.url}
                  alt={`${car.brand?.name} logo`}
                  className="img-fluid"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "40px",
                    objectFit: "contain",
                  }}
                  loading="lazy"
                />
                <span
                  className="badge mb-3 m-2"
                  style={{ backgroundColor: "blueviolet" }}
                >
                  {car.brand?.name}
                </span>
              </Link>
              <h1 className="mb-3 mt-2">{car.name}</h1>
            </div>

            <div className="mb-4">
              <h2 className="h4" style={{ color: "gray" }}>
                Vehicle Overview
              </h2>
              <p className="lh-base" style={{ textAlign: "justify" }}>
                {car.description}
              </p>
            </div>

            <div className="d-flex align-items-center mb-4">
              <h2 className="h3 mb-0">
                KES {Number(car.price).toLocaleString()}
              </h2>
              <span className="badge bg-success ms-3">{year} Model</span>
            </div>

            <div className="mb-4">
              <p className="text-muted small">Last updated: {updatedAt}</p>
              <div className="d-flex flex-wrap gap-2">
                <button
                  style={{ backgroundColor: "blueviolet" }}
                  className="btn text-white"
                  onClick={() => {
                    setcart([...cart, car]);
                    localStorage.setItem(
                      "cart",
                      JSON.stringify([...cart, car]),
                    );
                    notify();
                  }}
                  aria-label="Add to favorites"
                >
                  <RiHeartAddLine size={20} className="pb-1" />
                </button>
                <Link
                  className="btn btn-outline-primary"
                  to="/cart"
                  aria-label="View cart"
                >
                  <AiOutlineEye size={20} className="pb-1" />
                </Link>
                <Link
                  className="btn btn-outline-primary"
                  href={`https://wa.me/254707308556?text=I'm interested in the ${car.name} (${car.price} KES)`}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Contact via WhatsApp"
                >
                  <div className="d-flex align-items-center">
                    <div className="d-flex align-items-center border-end px-2">
                      <FaHeadphonesAlt size={20} className="pb-1 mt-1" />
                    </div>
                    <div className="d-flex align-items-center border-end px-2">
                      <SiWhatsapp size={20} className="pb-1 mt-1" />
                    </div>
                    <div className="d-flex align-items-center px-2">
                      0707 308 556
                    </div>
                  </div>
                </Link>
              </div>
            </div>

            <div className="mb-5">
              <h2 className="h4 mb-3">Technical Specifications</h2>
              <div className="row row-cols-2 row-cols-md-3 g-3">
                <div className="col">
                  <div className="border p-3 rounded h-100">
                    <p className="text-secondary mb-2">
                      <BsFuelPumpFill size={20} /> Fuel Type
                    </p>
                    <p className="mb-0">{car.fuelType}</p>
                  </div>
                </div>
                {car.seater && (
                  <div className="col">
                    <div className="border p-3 rounded h-100">
                      <p className="text-secondary mb-2">
                        <MdAirlineSeatReclineExtra size={25} /> Seats
                      </p>
                      <p className="mb-0">{car.seater}</p>
                    </div>
                  </div>
                )}
                {car.fuelTank && (
                  <div className="col">
                    <div className="border p-3 rounded h-100">
                      <p className="text-secondary mb-2">
                        <MdOutlinePropaneTank size={25} /> Fuel Capacity
                      </p>
                      <p className="mb-0">{car.fuelTank} Litres</p>
                    </div>
                  </div>
                )}
                {car.accelaration && (
                  <div className="col">
                    <div className="border p-3 rounded h-100">
                      <p className="text-secondary mb-2">
                        <MdOutlinePropaneTank size={25} /> 0-100 km/h
                      </p>
                      <p className="mb-0">{car.accelaration} seconds</p>
                    </div>
                  </div>
                )}

                <div className="col">
                  <div className="border p-3 rounded h-100">
                    <p className="text-secondary mb-2">
                      <TbEngine size={25} /> Mileage
                    </p>
                    <p className="mb-0">{car.mileage} Kms</p>
                  </div>
                </div>

                <div className="col">
                  <div className="border p-3 rounded h-100">
                    <p className="text-secondary mb-2">
                      <TbEngine size={25} /> Drive Type
                    </p>
                    <p className="mb-0">{car.drive}</p>
                  </div>
                </div>
                {car.horsepower && (
                  <div className="col">
                    <div className="border p-3 rounded h-100">
                      <p className="text-secondary mb-2">
                        <TbEngine size={25} /> Horse Power
                      </p>
                      <p className="mb-0">{car?.horsepower} Hp</p>
                    </div>
                  </div>
                )}

                <div className="col">
                  <div className="border p-3 rounded h-100">
                    <p className="text-secondary mb-2">
                      <AiOutlineColumnWidth size={25} /> Engine Size
                    </p>
                    <p className="mb-0">{car.engineSize} cc</p>
                  </div>
                </div>

                <div className="col">
                  <div className="border p-3 rounded h-100">
                    <p className="text-secondary mb-2">
                      <AiOutlineNodeIndex size={25} /> Transmission
                    </p>
                    <p className="mb-0">{car.transmission}</p>
                  </div>
                </div>
                {car.safetyrating && (
                  <div className="col">
                    <div className="border p-3 rounded h-100">
                      <p className="text-secondary mb-2">
                        <TbStars size={25} /> Safety Rating
                      </p>
                      <p className="mb-0">{car.safetyrating} stars</p>
                    </div>
                  </div>
                )}
                <div className="col">
                  <div className="border p-3 rounded h-100">
                    <p className="text-secondary mb-2">
                      <GiBackwardTime size={25} /> Year
                    </p>
                    <p className="mb-0">{car.yom}</p>
                  </div>
                </div>
                {car.size && (
                  <div className="col">
                    <div className="border p-3 rounded h-100">
                      <p className="text-secondary mb-2">
                        <MdCompareArrows size={25} /> Ground Clearance
                      </p>
                      <p className="mb-0">{car.size} mm</p>
                    </div>
                  </div>
                )}
                {car.torque && (
                  <div className="col">
                    <div className="border p-3 rounded h-100">
                      <p className="text-secondary mb-2">
                        <AiOutlineNodeIndex size={25} /> Torque
                      </p>
                      <p className="mb-0">{car.torque} Nm</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-12 mt-5">
            <div className="row">
              <div className="col-12 text-center mb-5">
                <h2 className="brand_title">
                  Similar{" "}
                  <span style={{ color: "blueviolet" }}>{car.brand?.name}</span>{" "}
                  Vehicles
                </h2>
              </div>
              {relatedCar.length > 0 ? (
                relatedCar.map((p) => (
                  <div className="col-md-6 col-lg-3 mb-4" key={p._id}>
                    <div className="card h-100">
                      <div className="d-flex justify-content-between p-3">
                        <p className="lead mb-0">{p.brand?.name}</p>
                        <Link
                          to={`/brand/${p.brand?.slug}`}
                          className="rounded-circle d-flex align-items-center justify-content-center shadow-1-strong"
                          style={{ width: "35px", height: "35px" }}
                          aria-label={`View ${p.brand?.name} brand`}
                        >
                          <img
                            src={p.brand?.image?.[0]?.url}
                            alt={p.brand?.name}
                            style={{
                              maxWidth: "100%",
                              maxHeight: "30px",
                              objectFit: "contain",
                            }}
                            loading="lazy"
                          />
                        </Link>
                      </div>
                      <Link
                        to={`/car/${p.slug}`}
                        className="text-center"
                        aria-label={`View ${p.name} details`}
                      >
                        <img
                          src={p.documents?.[0]?.url}
                          alt={p.name}
                          style={{
                            maxWidth: "100%",
                            maxHeight: "120px",
                            objectFit: "contain",
                          }}
                          className="border rounded"
                          loading="lazy"
                        />
                      </Link>
                      <div className="card-body d-flex flex-column">
                        <h3 className="text-center mb-4 h5">{p.name}</h3>
                        <div className="d-flex justify-content-between mb-2">
                          <span>KES {Number(p.price).toLocaleString()}</span>
                          <span>
                            <BsFuelPumpFill /> {p.fuelType}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between mb-3">
                          <span>
                            <TbStars /> {p.safetyrating}
                          </span>
                          <span>
                            <MdAirlineSeatReclineExtra /> {p.seater} Seats
                          </span>
                        </div>
                        <div className="mt-auto text-center">
                          <Link
                            className="btn my-2"
                            style={{
                              backgroundColor: "blueviolet",
                              color: "white",
                            }}
                            to={`/car/${p.slug}`}
                            aria-label={`View ${p.name} details`}
                          >
                            <AiOutlineEye size={20} className="pb-1" /> View
                            Details
                          </Link>
                          <button
                            className="btn btn-outline-primary my-2 mx-3"
                            onClick={() => {
                              setcart([...cart, p]);
                              localStorage.setItem(
                                "cart",
                                JSON.stringify([...cart, p]),
                              );
                              notify();
                            }}
                            aria-label={`Add ${p.name} to favorites`}
                          >
                            <GoHeart size={20} className="pb-1" /> Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-md-12 text-center">
                  <h4>
                    Currently no similar {car.brand?.name} vehicles available.
                  </h4>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CarView;
